import { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function NewPromptFolderModal({
  isOpen,
  onClose,
  editingFolderId = null,
  folderName = "",
  onSubmit,
  loading = false,
}) {
  const [name, setName] = useState("");

  useEffect(() => {
    if (isOpen) {
      setName(editingFolderId ? folderName : "");
    }
  }, [isOpen, editingFolderId, folderName]);

  const handleSubmit = () => {
    onSubmit({ name: name.trim() });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
        >
          <FiX size={18} />
        </button>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {editingFolderId ? "Edit folder" : "New prompt folder"}
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-600 dark:text-gray-300 mb-2">
              Folder name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. HR, Sales"
              className="w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!name.trim() || loading}
            className="px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60"
          >
            {loading ? "Saving..." : editingFolderId ? "Update" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
